import { localSegmentFlagsExist } from '@/data/flags/local-flags';

export function waitForSegmentFlags () {
    return new Promise((resolve) => {
        if (window.pendo?.segmentFlags || localSegmentFlagsExist()) {
            resolve();

            return;
        }
        const agentInterval = setInterval(() => {
            if (window.pendo?.segmentFlags) {
                clearInterval(agentInterval);
                resolve();
            }
        }, 10);
    });
}
